import Exceptions from "./Exceptions";
import { MainRouter, Tabs } from "./routes";
import { logout } from "./services/api/account";
import { APISettings } from "./services/api/api";
import { showConfirmationModal } from "./views/widgets/modal";

const Client = {
    /**
     * @type {{ id: string, fullname: string, role: string, role_specific: string }}
     */
    account: {},
    signedIn: false,
    isInitialized: false,

    version: {
        date: "07-20-22 01:35",
        number: "0.2.1",
    },

    get canApprove() {
        this.ensureSignedIn();

        return [ "admin", "province", "reviewer" ].includes(this.account.role);
    },

    get canEditSubmissions() {
        this.ensureSignedIn();

        return [ "admin", "province", "editor" ].includes(this.account.role);
    },

    get canPublishSubmissions() {
        this.ensureSignedIn();

        return [ "admin", "reviewer" ].includes(this.account.role);
    },

    isSelf(accountId) {
        return accountId === this.account.id;
    },

    initialize() {
        if(this.isInitialized) return;
        this.isInitialized = true;

        console.log("Version: ", this.version);

        this.environment = process.env.REACT_APP_ENVIRONMENT || "prod";

        // Check local storage for account details
        const currentAccountJSON = localStorage.getItem("account");
        const token = localStorage.getItem("token");

        if(currentAccountJSON && token && token !== "null") {
            this.logAccount(JSON.parse(currentAccountJSON), token);
        }
    },

    ensureSignedIn({ throwing = true } = {}) {
        if(!this.signedIn) {
            if(throwing) Exceptions.throw("Client not signed in.");
            return false;
        }

        return true;
    },

    logAccount(account, token) {
        this.account = account;
        this.signedIn = true;

        APISettings.token = token;

        // Store in local storage
        localStorage.setItem("token", token);
        localStorage.setItem("account", JSON.stringify(this.account));
    },

    async logout() {
        const willLogout = await showConfirmationModal({ title: "Confirm Logout", body: "Are you sure to log out?" });
        if(willLogout) {
            Client.signedIn = false;
            Client.account = {};
            
            localStorage.removeItem("token");
            localStorage.removeItem("account");

            MainRouter.goto("/login");
        }
    }
};

export default Client;